import React from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import { DASHBOARD_ITEM_TYPE } from "../../constants";
import { VESSEL_TYPE } from "../../../../constants/constants";
import { TrendComponentSettings } from "./trendComponentSettings";
import { LiveComponentSettings } from "./liveComponentSettings";

export const ComponentSettings = (props) => {
  const { vessel, startDate, setStartDate, endDate, setEndDate, item, chartRef, thickness, setThickness } = props;

  return (
    <Box position={"relative"} top={"16px"} padding={"16px"}>
      {
        item?.type === DASHBOARD_ITEM_TYPE.LIVE ? 
        <LiveComponentSettings
          vessel={vessel}
          item={item}
          chartRef={chartRef}
          thickness={thickness}
          setThickness={setThickness}
        /> :
        <TrendComponentSettings
          isSEPVessel={vessel.vesselType === VESSEL_TYPE.SEP}
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
        />
      }
    </Box>
  );
};

ComponentSettings.propTypes = {
  vessel: PropTypes.object,
  item: PropTypes.object,
  startDate: PropTypes.object,
  setStartDate: PropTypes.func,
  endDate: PropTypes.object,
  setEndDate: PropTypes.func,
  chartRef: PropTypes.object,
  thickness: PropTypes.number,
  setThickness: PropTypes.func,
};
